import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { Select2Module } from 'ng2-select2';

import { SharedModule } from '../shared/shared.module';
import { OfficeRoutingModule } from './office-routing.module';
import { AuthorizationModule } from './authorization/authorization.module';
import { MedicalAppointmentModule } from './medical-appointment/medical-appointment.module';
import { AccountStatusModule } from './account-status/account-status.module';
import { LaboratoryTestsModule } from './laboratory-tests/laboratory-tests.module';

import { HomeComponent } from './home/home.component';
import { OfficeComponent } from './office.component';
import { ProfileComponent } from './profile/profile.component';
import { OfficeContractComponent } from './office-contract/office-contract.component';
import { AuthModule } from '../auth/auth.module';
import { InfoPageComponent } from './info-page/info-page.component';
import { ServiceClientComponent } from './service-client/service-client.component';
import { RefundModule } from './refunds/refund.module';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    OfficeRoutingModule,
    AuthorizationModule,
    MedicalAppointmentModule,
    LaboratoryTestsModule,
    AccountStatusModule,
    Select2Module,
    AuthModule,
    RefundModule
  ],
  declarations: [HomeComponent, OfficeComponent, ProfileComponent, OfficeContractComponent, InfoPageComponent,ServiceClientComponent],
  providers : [ CurrencyPipe ]
})
export class OfficeModule { }



// WEBPACK FOOTER //
// /app/src/app/office/office.module.ts